/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Internalservererrormessage3Inputs */

const en_internalservererrormessage3 = /** @type {(inputs: Internalservererrormessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An internal error occurred. Please try again later.`)
};

const de_internalservererrormessage3 = /** @type {(inputs: Internalservererrormessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da ist was schiefgelaufen.`)
};

/**
* | output |
* | --- |
* | "An internal error occurred. Please try again later." |
*
* @param {Internalservererrormessage3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const internalservererrormessage3 = /** @type {((inputs?: Internalservererrormessage3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Internalservererrormessage3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_internalservererrormessage3(inputs)
	return de_internalservererrormessage3(inputs)
});
export { internalservererrormessage3 as "internalServerErrorMessage" }